import { useContext } from 'react'

import { UserFormContext } from '../context'

export function usePriceList() {
  const {
    priceLists,
    loadingPriceLists: loading,
    listPriceLists
  } = useContext(UserFormContext)

  return {
    priceLists,
    loading,
    listPriceLists
  }
}
